import React from 'react';
interface FieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
}
export function Field({
  label,
  htmlFor,
  error,
  hint,
  children,
  className = ''
}: FieldProps) {
  return <div className={className} data-id="element-1062" data-mp="3var8zqsti3ok">
      <label htmlFor={htmlFor} className="label" data-id="element-1063" data-mp="42wk9iztnplf">
        {label}
      </label>
      {children}
      {error ? <p className="mt-1 text-xs text-danger" role="alert" data-id="element-1064" data-mp="929h8wkeqd1q">
          {error}
        </p> : hint ? <p className="mt-1 text-xs text-mist/80" data-id="element-1065" data-mp="d206uwy76n4o">{hint}</p> : null}
    </div>;
}